"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceUUIDWithId = exports.replaceIdWithUUID = void 0;
var _replaceAll = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/replace-all"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var replaceIdWithUUID = exports.replaceIdWithUUID = function replaceIdWithUUID(obj) {
  var _context;
  var json = JSON.parse((0, _replaceAll.default)(_context = (0, _stringify.default)(obj)).call(_context, "\"id\":", "\"uuid\":"));
  return json;
};
var replaceUUIDWithId = exports.replaceUUIDWithId = function replaceUUIDWithId(obj) {
  var _context2;
  var json = JSON.parse((0, _replaceAll.default)(_context2 = (0, _stringify.default)(obj)).call(_context2, "\"uuid\":", "\"id\":"));
  return json;
};
//# sourceMappingURL=utils.js.map